module.exports = __webpack_public_path__ + "fc4bbc2bce9f88a27f412be1cbb363cb.pdf";